export const PLAN_PRICES = {
  monthly: { base: 29, pro: 65, proUpgrade: 36 },
  annual: { base: 24, pro: 54, proUpgrade: 30 },
} as const

export const PLAN_BASE_FEATURES_INCLUDED = [
  'Qualquer funcionário cria folhas de obra em 30 segundos, sem erros, sem formação',
  'Historial completo de cada cliente e viatura, nunca mais vai perder informação',
  'Marcações online sem conflitos, a agenda da oficina sempre organizada',
  'Sabe em tempo real quanto tempo cada mecânico gasta em cada trabalho',
  'Até 5 utilizadores, toda a equipa com acesso ao mesmo tempo',
  '5 GB de espaço para usar à sua vontade',
  'Fotos e vídeos associados às folhas de obra',
  'Migração do seu software atual completamente gratuita e em menos de 48h',
] as const

export const PLAN_BASE_FEATURES_EXCLUDED = [
  'Assistente técnico para o apoiar em todas as etapas',
  'Assistente técnico que sugere serviços antes de o cliente pedir',
] as const

export const PLAN_PRO_DIFF_FEATURES = [
  'Tem um assistente técnico que o apoia em todas as fases do serviço',
  'Lembretes para revisões de cada cliente, nunca mais perca dinheiro por esquecimento',
  'IA que apoia na criação de folhas de obra automática com perguntas que o ajudam a chegar a um melhor diagnóstico',
] as const

export const PLAN_PRO_EXTRA_FEATURES = [
  'Tudo incluído no plano Base',
  'Suporte prioritário, resposta em menos de 2 horas',
  'Formação da equipa incluída, caso necessário',
  'Acesso antecipado a novas funcionalidades',
  '15 GB de fotos e vídeos associados às folhas de obra',
] as const

export const SUPPORT_PHONE_E164 = '+351928490194'
export const SUPPORT_PHONE_DISPLAY = '+351 928 490 194'
export const SUPPORT_EMAIL = 'equipa.fixdauto@gmail.com'
